/*************************************************************************
 * 
 * KLEARNOW CONFIDENTIAL
 * __________________
 * 
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 * 
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */


const Images = {
  account: require('./images/Icon_My_Account.svg'),
  add_doc: require('./images/add-document.svg'),
  //cbplogo: require('./images/cbp-logo.png'),
  visa: require('./images/icon-Visa.png'),
  mastercard: require('./images/Icon_Mastercard.png'),
  missingPayment: require('./images/missing-payment-data.png'),
  bank: require('./images/bank.png'),
  errorIcon: require('./images/errorIcon.png'),
  lockIcon: require('./images/lock.png')
}
export default Images;